import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { ChevronDown, Info, LifeBuoy } from "react-feather";
import { Link } from "react-router-dom";
import SalaryBlock from "./Components/SalaryBlock";
import BankBlock from "./Components/BankBlock";
import { useGetPassTypeQuery } from "AppQuries/master/PassType/pass-type";
import Input from "Components/UI/Input";
import ImageUploader from "Components/UI/ImageUploder";
import { useGetLevyTypesQuery } from "AppQuries/master/Levy/levy-type";
import { useGetLevyAmountTypesQuery } from "AppQuries/master/Levy/levy-amount-type";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useFormattedVisaOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import { useGetForeignerLevyTypesQuery } from "AppQuries/master/Levy/foreigner-levy-type";
import ImageUploaderOCR from "Components/UI/Image/ImageUploaderOCR";
import ImageCropper from "Components/UI/Image/ImageCropper";

const activestatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const PassDetails = () => {
  const userData = useSelector(loggedInUser);
  const [dataFields, setDataFields] = useState([]);
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    clearErrors,
    trigger,
  } = useFormContext();
  const [companyCode, setCompanyCode] = useState(userData?.companyCode);
  const { data: passTypes } = useGetPassTypeQuery(
    {
      companyCode: companyCode,
      isTrue: true,
    }
    // {
    //   skip: !watch("companyCode"),
    // }
  );

  const { data: foreignerLevy } = useGetForeignerLevyTypesQuery({
    companyCode: watch("companyCode"),
    isTrue: true,
  });

  const handleLevyTypeSelect = (selecteOption) => {
    const selectedLevy = foreignerLevy.find(
      (p) => p.foreignWorkerCode === selecteOption
    );
    if (watch(`passTypeDetails[0].levyAmountTypes`) === "Daily") {
      setValue("passTypeDetails[0].levyAmount", selectedLevy.dailyAmount);
    } else if (watch(`passTypeDetails[0].levyAmountTypes`) === "Monthly") {
      setValue("passTypeDetails[0].levyAmount", selectedLevy.monthlyAmount);
    } else {
      setValue("passTypeDetails[0].levyAmount", 0);
    }
  };

  const handleLevyAmountTypeSelect = (selecteOption) => {
    
    const selectedLevy = foreignerLevy.find(
      (p) => p.foreignWorkerCode === watch(`passTypeDetails[0].levyTypes`)
    );

    if (selectedLevy) {
      if (selecteOption === "Daily") {
        setValue("passTypeDetails[0].levyAmount", selectedLevy.dailyAmount);
      } else if (selecteOption === "Monthly") {
        setValue("passTypeDetails[0].levyAmount", selectedLevy.monthlyAmount);
      } else {
        setValue("passTypeDetails[0].levyAmount", 0);
      }
    } else {
      setValue("passTypeDetails[0].levyAmount", 0);
    }
  };

  const visaTypeOptions = useFormattedVisaOption(watch("companyCode"));

  const setfrontImageBase64Value = (value, text) => {
    // if (text !== undefined || text !== null || text !== "") {
    
    //   const imageValue = text?.split("\n");
    //   const nricNumber = imageValue?.find((line) =>
    //     line.match(/^[STFG]\d{7}[A-Z]$/)
    //   );
    
    // }
    setValue("passTypeDetails[0].frontImage", value);
    clearErrors("passTypeDetails[0].frontImage");
    trigger("passTypeDetails[0].frontImage");
  };

  const setbackImageBase64Value = (value, text) => {
    
    setValue("passTypeDetails[0].backImage", value);
    clearErrors("passTypeDetails[0].backImage");
    trigger("passTypeDetails[0].backImage");
  };

  const setImageBase64Value = (name, value) => {
    setValue(name, value);
    clearErrors(name);
    trigger(name);
  };

  //   const passTypeOptions = Array.isArray(passTypes)
  //     ? passTypes
  //         .filter((o) => o.isActive === true)
  //         .map((o) => ({
  //           id: o.passCode,
  //           label: o.passName,
  //           value: o.passCode,
  //         }))
  //     : [];

  const passTypeHandler = (e) => {
    const passCode = e.target.value;
    const selectedPassType = passTypes.find(
      (p) => p.passCode === Number(passCode)
    );
    setValue("passCode", Number(passCode));
    setValue("passTypeDetails[0].passCode", Number(passCode));
    clearErrors("passCode");

    setDataFields(selectedPassType?.dataFields || []);
  };

  // const { data: levyTypes } = useGetLevyTypesQuery({
  //   companyCode: companyCode,
  //   isTrue: true,
  // });

  // const { data: levyAmountTypes } = useGetLevyAmountTypesQuery({
  //   companyCode: companyCode,
  //   isTrue: true,
  // });

  // const levyTypeOptions = Array.isArray(levyTypes)
  //   ? levyTypes
  //       ?.filter((o) => o.isActive === true)
  //       .map((o) => ({
  //         id: o.code,
  //         label: o.description,
  //         value: o.code.toString(),
  //       }))
  //   : [];
  // const levyAmountTypeOptions = Array.isArray(levyAmountTypes)
  //   ? levyAmountTypes
  //       ?.filter((o) => o.isActive === true)
  //       .map((o) => ({
  //         id: o.levyAmountTypeID,
  //         label: o.levyAmountTypeName,
  //         value: o.levyAmountTypeID.toString(),
  //       }))
  //   : [];

  const levyAmountTypeOptions = [
    {
      id: 1,
      label: "None",
      value: "None",
    },
    {
      id: 2,
      label: "Daily",
      value: "Daily",
    },
    {
      id: 3,
      label: "Monthly",
      value: "Monthly",
    },
  ];
  // useEffect(() => {
  //   const passCode = watch("passCode");
  //   const selectedPassType = passTypes.find(
  //     (p) => p.passCode === Number(passCode)
  //   );
  //   setDataFields(selectedPassType?.dataFields || []);
  // }, []);

  const frontImageTextExtractor = (text) => {};
  const backImageTextExtractor = (text) => {};

  useEffect(() => {
    const passCode = watch("passCode");
    const selectedPassType = passTypes?.find(
      (p) => p.passCode === Number(passCode)
    );
    setDataFields(selectedPassType?.dataFields || []);
  }, [watch("passCode"), passTypes]);

  return (
    <>
      <div>
        <div className="addproduct-icon list icon">
          <h5>
            <Info className="add-info" />
            <span>ID Details</span>
          </h5>
        </div>
        <label className="form-label">Pass Type</label>
        <div
          className="well well-lg mb-3"
          style={{ background: "#dbe0e6", padding: "20px" }}
        >
          <div className="form-row row">
            {passTypes?.map((pass, index) => (
              <div className="col-md-2 col-sm-2 col-lg-2" key={pass.passCode}>
                <div className="form-check">
                  <input
                    className={`form-check-input ${
                      errors.passCode ? "is-invalid" : ""
                    }`}
                    type="radio"
                    {...register("passCode", {
                      required: "Pass type is required",
                    })}
                    id={`passCode-${pass.passCode}`}
                    value={pass.passCode}
                    onChange={(e) => passTypeHandler(e)}
                    checked={
                      String(pass.passCode) === String(watch("passCode"))
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`passCode-${pass.passCode}`}
                  >
                    {pass.passName}
                  </label>
                </div>
              </div>
            ))}
          </div>

          {errors.passCode && (
            <div className="text-danger mt-2">{errors.passCode.message}</div>
          )}
        </div>

        <div className="row mb-3">
          {dataFields?.includes("nricNumber") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <input
                type="hidden"
                value={watch("passTypeDetails[0].passTypeID") || 0}
                {...register("passTypeDetails[0].passTypeID")}
              />
              <input
                type="hidden"
                value={watch("passCode") || 0}
                {...register("passTypeDetails[0].passCode")}
              />
              <Input
                name="passTypeDetails[0].nricNumber"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.nricNumber ? "is-invalid" : ""
                }`}
                label="NRIC/FIRN Number"
                labelClassName="form-label"
                required={false}
                requiredMessage="NRIC/FIRN Number is required"
                defaultValue={watch("passTypeDetails[0].nricNumber")}
              />
            </div>
          )}
          {dataFields?.includes("photoIdBarcode") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].photoIdBarcode"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.photoIdBarcode
                    ? "is-invalid"
                    : ""
                }`}
                label="Photo ID Barcode"
                labelClassName="form-label"
                required={false}
                requiredMessage="Photo ID Barcode is required"
                defaultValue={watch("passTypeDetails[0].photoIdBarcode")}
              />
            </div>
          )}
          {dataFields?.includes("issuedDate") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].issuedDate"
                type="date"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.issuedDate ? "is-invalid" : ""
                }`}
                label="Issued Date"
                labelClassName="form-label"
                required={false}
                requiredMessage="Issued Date is required"
                dateFormat="YYYY-MM-DD"
                defaultValue={watch("passTypeDetails[0].issuedDate")}
              />
            </div>
          )}
          {dataFields?.includes("sector") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].sector"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.sector ? "is-invalid" : ""
                }`}
                label="Sector"
                labelClassName="form-label"
                required={false}
                requiredMessage="Sector is required"
                defaultValue={watch("passTypeDetails[0].sector")}
              />
            </div>
          )}
          {dataFields?.includes("dateOfApplication") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].dateOfApplication"
                type="date"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.dateOfApplication
                    ? "is-invalid"
                    : ""
                }`}
                label="Date Of Application"
                labelClassName="form-label"
                required={false}
                requiredMessage="DateOfApplication is required"
                defaultValue={watch("passTypeDetails[0].dateOfApplication")}
                dateFormat="YYYY-MM-DD"
              />
            </div>
          )}
          {dataFields?.includes("idExpiryDate") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].idExpiryDate"
                type="date"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.idExpiryDate ? "is-invalid" : ""
                }`}
                label="ID Expiry Date"
                labelClassName="form-label"
                required={false}
                requiredMessage="ID Expiry Date is required"
                defaultValue={watch("passTypeDetails[0].idExpiryDate")}
                dateFormat="YYYY-MM-DD"
              />
            </div>
          )}
          {dataFields?.includes("sPassNumber") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].sPassNumber"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.sPassNumber ? "is-invalid" : ""
                }`}
                label="S Pass Number"
                labelClassName="form-label"
                required={false}
                requiredMessage="S Pass Number Date is required"
                defaultValue={watch("passTypeDetails[0].sPassNumber")}
              />
            </div>
          )}
          {dataFields?.includes("workPermitNumber") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].workPermitNumber"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.workPermitNumber
                    ? "is-invalid"
                    : ""
                }`}
                label="Work Permit Number"
                labelClassName="form-label"
                required={false}
                requiredMessage="Work Permit Number is required"
                defaultValue={watch("passTypeDetails[0].workPermitNumber")}
              />
            </div>
          )}
          {dataFields?.includes("workPermitRenewalDate") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].workPermitRenewalDate"
                type="date"
                placeholder=""
                className={`form-control  input ${
                  errors.passTypeDetails?.[0]?.workPermitRenewalDate
                    ? "is-invalid"
                    : ""
                }`}
                label="Work Permit Renewal Date"
                labelClassName="form-label"
                required={false}
                requiredMessage="Work Permit Renewal Date is required"
                defaultValue={watch("passTypeDetails[0].workPermitRenewalDate")}
                dateFormat="YYYY-MM-DD"
              />
            </div>
          )}
          {/* {dataFields?.includes("levyTypes") && ( */}
          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="passTypeDetails[0].levyTypes"
              type="commonSelect"
              placeholder=""
              className={`form-control ${
                errors.passTypeDetails?.[0]?.levyTypes ? "is-invalid" : ""
              }`}
              optionData={foreignerLevy?.map((levy) => ({
                id: levy.code,
                label: levy.description,
                value: levy.foreignWorkerCode,
              }))}
              onSelect={handleLevyTypeSelect}
              label="Levy Types"
              labelClassName="form-label"
              required={false}
              requiredMessage="Levy Types is required"
              defaultValue={watch("passTypeDetails[0].levyTypes")}
            />
          </div>
          {/* )} */}
          {/* {dataFields?.includes("levyAmountTypes") && ( */}
          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="passTypeDetails[0].levyAmountTypes"
              type="commonSelect"
              placeholder=""
              className={`form-control ${
                errors.passTypeDetails?.[0]?.levyAmountTypes ? "is-invalid" : ""
              }`}
              onSelect={handleLevyAmountTypeSelect}
              optionData={levyAmountTypeOptions}
              label="Levy Amount Types"
              labelClassName="form-label"
              required={false}
              requiredMessage="Levy Amount Types is required"
              defaultValue={watch("passTypeDetails[0].levyAmountTypes")}
            />
          </div>
          {/* )} */}
          {/* {dataFields?.includes("levyAmount") && ( */}
          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="passTypeDetails[0].levyAmount"
              type="number"
              placeholder=""
              className={`form-control ${
                errors.passTypeDetails?.[0]?.levyAmount ? "is-invalid" : ""
              }`}
              label="Levy Amount"
              labelClassName="form-label"
              required={false}
              requiredMessage="LevyAmount is required"
              defaultValue={watch("passTypeDetails[0].levyAmount")}
            />
            {/* <Controller
              name={`passTypeDetails[0].levyAmount`}
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  type="number"
                  className={`form-control ${
                    errors.passTypeDetails?.[0]?.levyAmount ? "is-invalid" : ""
                  }`}
                  value={field.value || 0}
                  onChange={(e) => {
                    const value = Number(e.target.value);

                    field.onChange(value);
                  }}
                />
              )}
            />

            

            {errors.passTypeDetails?.[index]?.levyAmount && (
              <div className="invalid-feedback">
                {errors.passTypeDetails?.[index]?.levyAmount?.message}
              </div>
            )} */}
          </div>
          {/* )} */}
          {dataFields?.includes("typeOfVisa") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name={`passTypeDetails[0].typeofVisa`}
                type="commonSelect"
                placeholder="Type of Visa"
                className={`form-control ${
                  errors?.otherVisaDetails?.[0]?.typeofVisa ? "is-invalid" : ""
                }`}
                optionData={visaTypeOptions?.map((option) => ({
                  label: option.label,
                  value: option.value?.toString(),
                }))}
                onSelect={(selectedOption) => {
                  setValue(`otherVisaDetails[0].typeofVisa`, selectedOption);
                }}
                label="Visa Type"
                labelClassName="form-label"
                required={false}
                requiredMessage=""
                // style={{ width: "200px" }}
                labelInValue
                defaultValue={{ value: watch("passTypeDetails[0].typeOfVisa") }}
              />
              {/* <Input
                name="passTypeDetails[0].typeOfVisa"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.typeOfVisa ? "is-invalid" : ""
                }`}
                label="Type of Visa"
                labelClassName="form-label"
                required={false}
                requiredMessage="Type of visa is required"
                defaultValue={watch("passTypeDetails[0].typeOfVisa")}
              /> */}
            </div>
          )}
          {dataFields?.includes("purpose") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].purpose"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.purpose ? "is-invalid" : ""
                }`}
                label="Purpose"
                labelClassName="form-label"
                required={false}
                requiredMessage="Purpose is required"
                defaultValue={watch("passTypeDetails[0].purpose")}
              />
            </div>
          )}
          {dataFields?.includes("remarks") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].remarks"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.remarks ? "is-invalid" : ""
                }`}
                label="Remarks"
                labelClassName="form-label"
                required={false}
                requiredMessage="Remarks is required"
                defaultValue={watch("passTypeDetails[0].remarks")}
              />
            </div>
          )}
          {dataFields?.includes("pcpExpiryDate") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].pcpExpiryDate"
                type="date"
                placeholder=""
                className={`form-control ${
                  errors.pcpExpiryDate ? "is-invalid" : ""
                }`}
                label="PCP Expiry Date"
                labelClassName="form-label"
                required={false}
                requiredMessage="PCP Expiry Date is required"
                defaultValue={watch("passTypeDetails[0].pcpExpiryDate")}
                dateFormat="YYYY-MM-DD"
              />
            </div>
          )}
          {dataFields?.includes("pcpClinic") && (
            <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
              <Input
                name="passTypeDetails[0].pcpClinic"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.passTypeDetails?.[0]?.pcpClinic ? "is-invalid" : ""
                }`}
                label="PCP Clinic"
                labelClassName="form-label"
                required={false}
                requiredMessage="PCP Clinic is required"
                defaultValue={watch("passTypeDetails[0].pcpClinic")}
              />
            </div>
          )}

          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="passTypeDetails[0].isActive"
              type="commonSelect"
              placeholder=""
              className={`form-control ${
                errors.passTypeDetails?.[0]?.isActive ? "is-invalid" : ""
              }`}
              label="Active Status"
              labelClassName="form-label"
              optionData={activestatus}
              required={false}
              requiredMessage="Active Status is required"
              onChange={(selectedOption) => {
                setValue(
                  "passTypeDetails[0].isActive",
                  selectedOption ? selectedOption.value : null
                );
                // trigger("isActive");
              }}
              defaultValue={true}
            />
          </div>
        </div>
      </div>
      <div>
        <div className="addproduct-icon list icon">
          <h5>
            <Info className="add-info" />
            <span>ID Images</span>
          </h5>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Front Image</label>
            <div>
              <ImageCropper
                base64Value={watch("passTypeDetails[0].frontImage")}
                setBase64Value={setfrontImageBase64Value}
                // extractTextHandler={frontImageTextExtractor}
              />
              {errors?.passTypeDetails?.[0]?.frontImage && (
                <div className="text-danger mt-2">
                  {errors.passTypeDetails?.[0].frontImage.message}
                </div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label className="form-label">Back Image</label>

            <ImageCropper
              base64Value={watch("passTypeDetails[0].backImage")}
              setBase64Value={setbackImageBase64Value}
              // extractTextHandler={backImageTextExtractor}
            />
            {errors?.passTypeDetails?.[0]?.backImage && (
              <div className="text-danger mt-2">
                {errors.passTypeDetails?.[0].backImage.message}
              </div>
            )}
          </div>
        </div>
        <div className="row mb-3">
          {dataFields?.includes("sgPassFrontImage") && (
            <div className="col-md-6">
              <label className="form-label">SG Pass Front Image</label>
              <div>
                <ImageCropper
                  base64Value={watch("passTypeDetails[0].sgPassFrontImage")}
                  // setBase64Value={setfrontImageBase64Value}
                  setBase64Value={(value) =>
                    setImageBase64Value(
                      "passTypeDetails[0].sgPassFrontImage",
                      value
                    )
                  }
                />
                {errors?.passTypeDetails?.[0]?.sgPassFrontImage && (
                  <div className="text-danger mt-2">
                    {errors.passTypeDetails?.[0].sgPassFrontImage.message}
                  </div>
                )}
              </div>
            </div>
          )}
          {dataFields?.includes("sgPassBackImage") && (
            <div className="col-md-6">
              <label className="form-label">SG Pass Back Image</label>

              <ImageCropper
                base64Value={watch("passTypeDetails[0].sgPassBackImage")}
                setBase64Value={(value) =>
                  setImageBase64Value(
                    "passTypeDetails[0].sgPassBackImage",
                    value
                  )
                }
              />
              {errors?.passTypeDetails?.[0]?.sgPassBackImage && (
                <div className="text-danger mt-2">
                  {errors.passTypeDetails?.[0].sgPassBackImage.message}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PassDetails;
